import React from 'react';
import { useTranslation } from 'react-i18next';
import vivaIcon from 'images/brands/etn/vivaIcon.svg';

/**
 * VivaPromoBadge component.
 * Render a promotional badge for Viva with animated shine effect.
 */
export default function VivaPromoBadge() {
  const { t } = useTranslation('general');

  return (
    <div className="relative inline-flex items-center bg-[#08a33f] rounded-full px-2.5 overflow-hidden">
      <span
        className="pointer-events-none absolute inset-y-0 left-0
          w-8 bg-gradient-to-r from-[#08a33f] via-white/30 to-white/10
          -skew-x-[10deg] animate-[shinyMove_2s_ease-in-out_forwards]"
      />
      <div className="relative flex items-center justify-center gap-2">
        <img src={vivaIcon} alt="Viaja Ahorrando" className="h-5 w-5" />
        <span className="text-xs font-semibold text-white">{t('viva_promo_label')}</span>
      </div>
    </div>
  );
}
